import type { ActionSource as ActionSourceAnalyticsActions } from 'owa-analytics-types';
import type { ActionSource as ActionSourceMailStore } from 'owa-mail-store';
import { lazyOnDelete } from 'owa-mail-commands-actions';
import type { IncompleteGroupHeaderInfo } from 'owa-mail-triage-action-utils/lib/IncompleteGroupHeaderInfo';
import { getSelectedTableView } from 'owa-mail-list-store';
import getEffectiveRowKeys from 'owa-mail-list-store/lib/utils/getEffectiveRowKeys';

export default function onDelete(
    actionSourceMailStore: ActionSourceMailStore,
    actionSourceAnalyticsActions: ActionSourceAnalyticsActions,
    isExplicitSoftDelete?: boolean,
    targetWindow?: Window,
    rowKeysToUse?: string[],
    incompleteGroupHeaderInfo?: IncompleteGroupHeaderInfo
): void {
    const effectiveRowKeys = rowKeysToUse ?? getEffectiveRowKeys(getSelectedTableView());
    lazyOnDelete.importAndExecute(
        actionSourceMailStore,
        actionSourceAnalyticsActions,
        isExplicitSoftDelete,
        targetWindow,
        undefined, // tableViewToUse
        effectiveRowKeys,
        undefined, // isInVirtualSelectAllModeToUse
        undefined, // selectedNodeIdsToUse
        undefined, // virtualSelectAllExclusionListToUse
        incompleteGroupHeaderInfo
    );
}
